import { useMemo } from 'react';
import { ImageGenerationType, VideoGenerationType } from '@/.gql/graphql';
import { useProfileContext } from '@/src/providers';

export type GenerationType = ImageGenerationType | VideoGenerationType;

export interface PromoCheckResult {
  isActive: boolean;
  isFree: boolean;
  remainingGenerations?: number;
  promoName?: string;
  endDate?: string;
}

export const usePromoCheck = (generationType: GenerationType | null) => {
  const profile = useProfileContext();

  const promoCheck = useMemo((): PromoCheckResult => {
    if (!profile?.userPromoInfo?.activePromos || !generationType) {
      return { isActive: false, isFree: false };
    }

    // Находим промо для данного типа генерации
    const relevantPromo = profile.userPromoInfo.activePromos.find((promo) =>
      promo.imageGenerationTypes.includes(generationType as ImageGenerationType) ||
      promo.videoGenerationTypes.includes(generationType as VideoGenerationType),
    );

    if (!relevantPromo || relevantPromo.remainingGenerations <= 0) {
      return { isActive: false, isFree: false };
    }

    return {
      isActive: true,
      isFree: relevantPromo.remainingGenerations > 0,
      remainingGenerations: relevantPromo.remainingGenerations,
      promoName: relevantPromo.name,
      endDate: relevantPromo.endDate,
    };
  }, [profile, generationType]);

  return { promoCheck, loading: false };
};
